import React from 'react';
import Portal from '@atlaskit/portal';
export var MediaViewerPortal = function MediaViewerPortal(_ref) {
  var children = _ref.children;
  return (
    /*#__PURE__*/
    // This zIndex matches with zIndex used by DS Modal and Jira Issue View Modal.
    // This value makes layers stack work correctly:
    //  -> Issue View -> Media Viewer -> DS Modal
    React.createElement(Portal, {
      zIndex: 510
    }, children)
  );
};